import createReactComponent from '../createReactComponent';
export default createReactComponent('pray', 'IconPray', [
  ['path', { d: 'M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-0' }],
  ['path', { d: 'M7 20h8l-4 -4v-7l4 3l2 -2', key: 'svg-1' }],
]);
